// extracted by mini-css-extract-plugin
module.exports = {"cls1":"mobile-Main-module--cls1--3QczY","cls2":"mobile-Main-module--cls2--3GDrD mobile-Main-module--cls1--3QczY"};